import { useEventbriteUrl } from '@/common/constants/useEventbriteUrl';
import { AlertOutlineIcon, Button, InlineAlert } from '@eventbrite/marmalade';
import Link from 'next/link';
import React from 'react';
import styles from './MaximumAttempReached.module.scss';

const MaximumAttempReached: React.FC = () => {
  const CONTACT_ORGANIZER_URL = useEventbriteUrl('CONTACT_ORGANIZER_URL');
  return (
    <div className={styles['max-attempt-reached']}>
      <InlineAlert
        closeTitle="Close"
        cta={
          <Button variant="ghost" className={styles.button}>
            <Link href={CONTACT_ORGANIZER_URL} passHref>
              How to contact the event organizer
            </Link>
          </Button>
        }
        description="That information does not match the order. You have exceeded the maximum number of attempts. If you contact the event organizer, they can usually help."
        icon={<AlertOutlineIcon />}
        title="Maximum attempts reached"
        variant="danger"
        className={styles['inline-alert']}
      />
    </div>
  );
};

export default MaximumAttempReached;
